import "./theme/_customer-form.scss";

$('form[id^="sccCustomerForm"], form[id*="sccCustomerForm"]').each(function () {
  // form values
  const form = $(this)
  const formId = form.attr('id')
  const formEvent = form.attr('data-event')
  const $rsamel = form.find('#' + formId + '-rsamel')

  // JSON data url for event
  let dataUrl = '/fileadmin/data/competitions.' + formEvent + '.json';

  // lang
  const lang = $('html').attr('lang') === 'en' ? 'en' : 'de';

  // select fields
  const eventSelectField = document.getElementById(formId + '-topicEvent');
  const competitionSelectField = document.getElementById(formId + '-competition');
  // hidden fields
  const eventSelectHiddenField = document.getElementById(formId + '-topicEventHidden');
  const competitionSelectHiddenField = document.getElementById(formId + '-competitionHidden');
  const eventNameHiddenField = document.getElementById(formId + '-topicEventNameHidden');

  // sort countries
  const lcountrySelect = document.getElementById(formId + '-lcountry');
  if (lcountrySelect) {
    const optionsArray = Array.from(lcountrySelect.options);
    const firstOption = optionsArray.shift(); // Remove the first option
    optionsArray.sort((a, b) => a.text.localeCompare(b.text));
    lcountrySelect.innerHTML = '';
    lcountrySelect.add(firstOption); // Add the first option back
    optionsArray.forEach(option => lcountrySelect.add(option));
  }
  const rcountrySelect = document.getElementById(formId + '-rcountry');
  if (rcountrySelect) {
    const optionsArray = Array.from(rcountrySelect.options);
    const firstOption = optionsArray.shift(); // Remove the first option
    optionsArray.sort((a, b) => a.text.localeCompare(b.text));
    rcountrySelect.innerHTML = '';
    rcountrySelect.add(firstOption); // Add the first option back
    optionsArray.forEach(option => rcountrySelect.add(option));
  }

  fetchJSON(dataUrl)
    .then(jsonText => {
      const data = JSON.parse(jsonText);

      if (!eventSelectHiddenField.value) {
        competitionSelectField.disabled = true;
      }

      // populate event name field
      const eventNames = getUniqueEventNames(data, lang);

      // if no hidden eventSelect field is set and only one event is available, 
      // set the select to the only event. and populate the hidden field
      if (Object.keys(eventNames).length === 1 && (!eventSelectHiddenField.value || eventSelectHiddenField.value === '')) {
        populateSelectField(eventSelectField, eventNames, Object.keys(eventNames)[0]);
        eventSelectHiddenField.value = Object.keys(eventNames)[0];
        eventNameHiddenField.value = eventNames[Object.keys(eventNames)[0]];
      } else {
        populateSelectField(eventSelectField, eventNames, eventSelectHiddenField.value);
        eventNameHiddenField.value = eventNames[eventSelectHiddenField.value];
      }

      // next, populate the competition names if user posted them
      if (eventNameHiddenField.value) {
        const competitionNames = getCompetitionsByEventId(data, eventSelectHiddenField.value, lang);
        competitionSelectField.disabled = true;
        competitionSelectField.innerHTML = '';

        if (Object.keys(competitionNames).length > 0) {
          // default option
          const defaultOption = document.createElement('option');
          defaultOption.text = (lang === 'en') ? 'Please choose' : 'Bitte wählen';
          defaultOption.value = '';
          competitionSelectField.appendChild(defaultOption);
          // dynamic options
          populateSelectField(competitionSelectField, competitionNames, competitionSelectHiddenField.value);
          competitionSelectField.disabled = false;
        }
      } 

      // add listener for select
      eventSelectField.addEventListener('change', function (e) {
        const competitionNames = getCompetitionsByEventId(data, e.target.value, lang);

        // set name of event to a hidden field for later usage in Subject of Form
        eventSelectHiddenField.value = e.target.value;
        if (Object.keys(eventNames).length > 0 && eventNameHiddenField) {
          if (eventNames[e.target.value]) {
            eventNameHiddenField.value = eventNames[e.target.value];
          }
        }
        competitionSelectField.innerHTML = '';

        if (Object.keys(competitionNames).length > 0) {
          // default option
          const defaultOption = document.createElement('option');
          defaultOption.text = (lang === 'en') ? 'Please choose' : 'Bitte wählen';
          defaultOption.value = '';
          competitionSelectField.appendChild(defaultOption);
          // dynamic options
          populateSelectField(competitionSelectField, competitionNames, competitionSelectHiddenField.value);
          competitionSelectField.disabled = false;
        } else {
          competitionSelectField.disabled = true;
        }
      });
      
      competitionSelectField.addEventListener('change', function (e) {
        competitionSelectHiddenField.value = e.target.value;
      });
    })
    .catch(error => {
      console.error('Error fetching or processing the JSON:', error);
    });

  /**
   * Retrieves unique event names from the provided data based on the specified language.
   *
   * @param {Array} data - The array of data objects containing event information.
   * @param {string} lang - The language code ('de' for German, 'en' for English) to determine which event name field to use.
   * @returns {Object} An object where the keys are event IDs and the values are the corresponding event names in the specified language.
   */
  function getUniqueEventNames(data, lang) {
    const key = lang === 'de' ? 'EventNameDE__c' : 'EventNameEN__c';
    const eventNames = {};

    data.forEach(row => {
      if (!eventNames[row.Event__r.Id]) {
        eventNames[row.Event__r.Id] = row.Event__r[key];
      }
    });

    return eventNames;
  }

  /**
   * Retrieves a dictionary of competitions by their event ID.
   *
   * @param {Array} data - The array of competition data objects.
   * @param {string} eventId - The ID of the event to filter competitions.
   * @param {string} lang - The language code ('de' for German, 'en' for English) to determine the competition name field.
   * @returns {Object} An object where the keys are competition IDs and the values are competition names.
   */
  function getCompetitionsByEventId(data, eventId, lang) {
    const key = (lang === 'de' ? 'CompetitionNameDE__c' : 'CompetitionNameEN__c');
    const competitions = {};

    data.forEach(row => {
      if (!competitions[row.Id]) {
        competitions[row.Id] = row[rtrim(key)];
      }
    });

    return competitions;
  }

  // Function to populate the select field
  function populateSelectField(selectElement, options, defaultValue) {
    // Iterate over the options object and create option elements
    for (const [value, text] of Object.entries(options)) {
      const option = document.createElement('option');
      option.value = value;
      option.text = text;
      if (value === defaultValue) {
        option.selected = true;
      }
      selectElement.appendChild(option);
    }
  }

  function fetchJSON(url) {
    return fetch(url)
      .then(response => response.text());
  }

  if ($rsamel.length > 0) {
    var $toggleElements = $('.rsamel-required-group')

    const renderToggleElements = () => {
      if ($rsamel.get(0).checked) {
        $toggleElements.removeAttr('required')
        $toggleElements.closest('.form-group').removeClass('visible')
      } else {
        $toggleElements.attr('required', 'required')
        $toggleElements.closest('.form-group').addClass('visible')
      }
    }

    $rsamel.on('change', () => renderToggleElements())
    renderToggleElements()

    // set lang
    if ($('html').attr('lang') === 'en') {
      form.find('#' + formId + '-language').val('en')
    } else {
      form.find('#' + formId + '-language').val('de')
    }
  }
});

/**
 * Removes trailing characters from a string.
 *
 * @param {string} str - The input string to trim.
 * @param {string} [characters=" \n\r\t\v\0"] - A string containing the characters to be trimmed from the end of the input string.
 * @returns {string} - The trimmed string.
 */
function rtrim(str, characters = " \n\r\t\v\0") {
  const regex = new RegExp('[' + characters.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ']+$');
  return str.replace(regex, '');
}
